import {
  useAdAccountMasterToken,
  useAdManager,
  useIntegrationApi,
  useShowSpinner,
  useTiktok
} from 'hooks';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useBrandStore } from 'stores';

const IntegrationsStoreLoader: React.FC<React.PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const { loading: adAccountLoading, refreshAdAccount } = useAdManager();
  const { retrieveMasterTokenAdAccounts } = useAdAccountMasterToken();
  const { getTiktokAdAccount } = useTiktok();
  const { brand } = useBrandStore();
  const { fetchIntegrationsHistory, loading } = useIntegrationApi();

  const allLoading = loading || adAccountLoading;

  useShowSpinner({ show: allLoading });

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    if (!brand?.brandId) {
      navigate('/brands');
      return;
    }

    if (brand.brandId) {
      Promise.all([
        fetchIntegrationsHistory(),
        refreshAdAccount({ brandId: brand.brandId }),
        getTiktokAdAccount({ brandId: brand.brandId }),
        retrieveMasterTokenAdAccounts()
      ])
        /* Children still render after a failure; report it rather than leave it unhandled */
        .catch(error => console.error('Failed to load brand integrations', error))
        .finally(() => setLoaded(true));
    }
  }, [brand?.brandId]);

  if (!loaded) return null;

  return <>{children}</>;
};

export default IntegrationsStoreLoader;
